import { render } from "./PrivateLayout.vue?vue&type=template&id=564cca7e&scoped=true"
import script from "./PrivateLayout.vue?vue&type=script&lang=js"
export * from "./PrivateLayout.vue?vue&type=script&lang=js"

import "./PrivateLayout.vue?vue&type=style&index=0&id=564cca7e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564cca7e"]])

export default __exports__